module.exports = __webpack_public_path__ + "static/media/arrow-right-active.f09176e2.svg";